import React, { useContext } from 'react';

import { useChildComponent } from '@gogame/hooks-ts';

import Tiles, { useSelectableRows } from 'scenes/Gallery/components/Tiles';

import CreativeTile from './CreativeTile';
import CreativesDataTableContext from './CreativesDataTableContext';
import BatchToolbar from './components/BatchToolbar';
import Toolbar from './components/Toolbar';

const CreativesTiles = ({ withTitle, height, tabs, showConceptLink }) => {
  const { data, isLoading, isRefetching, tableSettings, onChangeSettings } =
    useContext(CreativesDataTableContext);

  const [childComponent, openChildComponent] = useChildComponent();

  const { selectedRows, isSelected, onSelect, onUnselectAll } =
    useSelectableRows();

  const handleChangeSettings = (pagination) => {
    onChangeSettings({
      ...pagination,
      orderBy: tableSettings?.orderBy,
      orderDir: tableSettings?.orderDir,
    });
  };

  return (
    <React.Fragment>
      <Tiles
        toolbarComponent={<Toolbar withTitle={withTitle} tabs={tabs} />}
        selectableRowToolbarComponent={
          <BatchToolbar
            selectedRows={selectedRows}
            openChildComponent={openChildComponent}
          />
        }
        selectedRowsCount={selectedRows.length}
        onUnselectAll={onUnselectAll}
        tileComponent={CreativeTile}
        tileProps={{
          isSelected,
          onSelect,
          openChildComponent,
          showConceptLink,
        }}
        rows={data?.rows}
        isLoading={isLoading}
        isRefetching={isRefetching}
        limit={tableSettings?.limit}
        offset={tableSettings?.offset}
        count={data?.count}
        withTitle={withTitle}
        height={height}
        onChangeSettings={handleChangeSettings}
      />
      {childComponent}
    </React.Fragment>
  );
};

export default CreativesTiles;
